export const getApiErrorStatus = (error: unknown): number | undefined => {
  if (!error || typeof error !== 'object') {
    return undefined;
  }

  const apiError = error as {
    status?: number;
    statusCode?: number;
    response?: { status?: number };
  };

  return apiError.status ?? apiError.statusCode ?? apiError.response?.status;
};

export const getApiErrorDetail = (error: unknown): string | undefined => {
  if (!error || typeof error !== 'object') {
    return undefined;
  }

  const apiError = error as {
    detail?: string;
    response?: { detail?: string } | string | null;
    result?: { detail?: string } | string | null;
  };

  if (apiError.detail) return apiError.detail;

  if (typeof apiError.response === 'object' && apiError.response !== null) {
    return apiError.response.detail;
  }

  if (typeof apiError.result === 'object' && apiError.result !== null) {
    return apiError.result.detail;
  }

  if (typeof apiError.response === 'string') {
    try {
      return JSON.parse(apiError.response).detail;
    } catch {
      return undefined;
    }
  }

  if (typeof apiError.result === 'string') {
    try {
      return JSON.parse(apiError.result).detail;
    } catch {
      return undefined;
    }
  }

  return undefined;
};
